const BackupCodeIcon = () => (
  <svg width='17' height='21' viewBox='0 0 17 21' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <path
      d='M15.75 12.75V10.125C15.75 9.22989 15.3944 8.37145 14.7615 7.73851C14.1286 7.10558 13.2701 6.75 12.375 6.75H10.875C10.5766 6.75 10.2905 6.63147 10.0795 6.4205C9.86853 6.20952 9.75 5.92337 9.75 5.625V4.125C9.75 3.22989 9.39442 2.37145 8.76149 1.73851C8.12855 1.10558 7.27011 0.75 6.375 0.75H4.5M6.75 0.75H1.875C1.254 0.75 0.75 1.254 0.75 1.875V19.125C0.75 19.746 1.254 20.25 1.875 20.25H14.625C15.246 20.25 15.75 19.746 15.75 19.125V9.75C15.75 7.36305 14.8018 5.07387 13.114 3.38604C11.4261 1.69821 9.13695 0.75 6.75 0.75Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default BackupCodeIcon
